<template>
  <AppBanner>
    Edit District
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader
      :is-loading="loading"
      text="Loading district..."
    />
  </template>

  <template v-else-if="!district">
    <h1 class="mt-5 flex items-center justify-center h-full">
      Unable to load district. Please try again.
    </h1>
  </template>

  <template v-else>
    <DistrictForm
      :model="district"
      :provinces="provinces"
    />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { DistrictForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const district = ref(null);
const provinces = ref(null);

const loadDistrict = async () => {
  const response = await useHttp().get(`/districts/${route.params.district}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    district.value = response.data;
  }
};

onMounted(async () => {
  await Promise.all([
    loadDistrict(),
    loadProvinces(),
  ]);

  loading.value = false;
});

const loadProvinces = async () => {
  const response = await useHttp().get('/util/provinces');

  if (response.statusCode === HttpStatusCode.Ok) {
    provinces.value = response.data.items;
  }
};
</script>
